<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="550"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="hrissecondary">
              mdi-plus-circle
            </v-icon>
          </v-btn>
        </template>
        <span>Add Company into Payroll Cycle</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Company"
      text="Add Payroll Company into Payroll Cycle"
      class="mb-0"
      :loading="loading"
      max-height="1000px"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-data-table
                v-model="selectedCompanies"
                v-validate="'required'"
                :items="filteredCompanies"
                disable-pagination
                :error-messages="errors.collect('selectedCompanies')"
                data-vv-name="selectedCompanies"
                data-vv-as="payroll companies"
                hide-default-footer
                show-select
                dense
                :headers="headers"
                item-key="id"
                item-value="id"
                :height="tableHeight"
                class="overflow"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title class="pa-0">
                      Payroll Companies:
                    </v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
              <span class="red--text text--lighten-1 caption">{{ errors.first('selectedCompanies') }}</span>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter company by name"
                append-icon="search"
                label="Search Company"
                hide-no-data
                hide-selected
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          create
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        searchInput: '',
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'name',
          },
        ],
        selectedCompanies: [],
        companies: [],
        appOrg: process.env.VUE_APP_ORG,
      }
    },

    computed: {
      filteredCompanies () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        return this.companies.filter(function (company) {
          return company.is_active && (company.name.toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1)
        })
      },

      tableHeight () {
        if (this.companies.length <= 2) return '100px'

        if (this.companies.length <= 6) return '200px'

        if (this.companies.length <= 10) return '300px'

        return '400px'
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loading = true

        this.$api.hrisCompanies().list('?organization=' + this.appOrg)
          .then(res => {
            this.companies = _.orderBy(res.data, ['name'], ['asc'])  

            this.loading = false
          })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            
            this.progressing = true

            this.$api.payrollCycleTransactions().create(this.payrollCycleTransaction.id, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.progressing = false

                this.dialog = false
              })
          })
      },

      prepareFormData () {
        return {
          selected_payroll_companies: this.selectedCompanies.map(company => { return company.id }),
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    max-height:550px;
    overflow: auto;
  }
</style>
